import { render, staticRenderFns } from "./data-validation-page.vue?vue&type=template&id=b41c3e0a&scoped=true"
import script from "./data-validation-page.vue?vue&type=script&lang=js"
export * from "./data-validation-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b41c3e0a",
  null
  
)

export default component.exports